import React, { useEffect, useMemo, useState } from 'react';
import ModalGeneral from './modal-general';
import Select from 'react-select';
import transformWord from '../../utils/transformWord'

const ModalParcelas = ({
  isOpen,
  handleClose,
  onSubmit,
  parcela = null,
  catalogosBaja = [],
  etiquetas,
}) => {
  const [formData, setFormData] = useState({
    nombreParcela: '',
    idCatParcelaBaja: '',
  });
  const [errors, setErrors] = useState({});

  const opcionesCatalogo = useMemo(() => {
    if (!catalogosBaja) {
      return [];
    }

    const source = Array.isArray(catalogosBaja)
      ? catalogosBaja
      : Array.isArray(catalogosBaja.motivos)
        ? catalogosBaja.motivos
        : [];

    return source.map(item => ({
      value: String(item?.id || ''),
      label: item?.nombre || '',
    }));
  }, [catalogosBaja]);

  useEffect(() => {
    if (!isOpen) {
      return;
    }

    setFormData({
      nombreParcela: parcela?.nombre || '',
      idCatParcelaBaja: '',
    });
    setErrors({});
  }, [isOpen, parcela]);

  const onClose = () => {
    setErrors({});
    handleClose();
  };

  const onChange = event => {
    const { name, value } = event.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));

    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: '',
      }));
    }
  };

  const onChangeSelect = option => {
    const value = option ? option.value : '';
    setFormData(prev => ({
      ...prev,
      idCatParcelaBaja: value,
    }));

    if (errors.idCatParcelaBaja) {
      setErrors(prev => ({
        ...prev,
        idCatParcelaBaja: '',
      }));
    }
  };

  const validate = () => {
    const nextErrors = {};

    if (!String(formData.nombreParcela || '').trim()) {
      nextErrors.nombreParcela = `Debe seleccionar una ${transformWord(etiquetas?.parcela, ['singular','lowercase'])}`;
    }
    if (!String(formData.idCatParcelaBaja || '').trim()) {
      nextErrors.idCatParcelaBaja = 'Debe seleccionar un motivo de baja';
    }

    setErrors(nextErrors);
    return Object.keys(nextErrors).length === 0;
  };

  const handleSubmit = () => {
    if (!validate()) {
      return;
    }

    const payload = {
      id_parcela: parcela?.id,
      nombre_parcela: String(formData.nombreParcela).trim(),
      id_cat_parcelas_bajas: Number(formData.idCatParcelaBaja),
    };

    if (typeof onSubmit === 'function') {
      onSubmit(payload, { parcela });
      return;
    }

    handleClose();
  };

  return (
    <ModalGeneral
      show={isOpen}
      title={`Baja ${transformWord(etiquetas?.parcela, ['singular','lowercase'])}`}
      onSave={handleSubmit}
      onClose={onClose}
      loading={false}>
      <div className="modal-body" style={{ overflowY: 'auto' }}>
        <div className="row my-3">
          <div className="col-12">
            <label htmlFor="nombreParcela" style={{ display: 'block', marginBottom: '6px', color: '#666' }}>
              {transformWord(etiquetas?.parcela, ['singular','capitalize'])}
            </label>
            <input
              id="nombreParcela"
              name="nombreParcela"
              value={formData.nombreParcela}
              readOnly
              className="form-control"
              style={{
                border: `1px solid ${errors.nombreParcela ? '#D9534F' : '#DADADA'}`,
                backgroundColor: '#F5F5F5',
              }}
            />
            {errors.nombreParcela ? <small style={{ color: '#D9534F' }}>{errors.nombreParcela}</small> : null}
          </div>
        </div>

        <div className="row my-3">
          <div className="col-12">
            <label htmlFor="idCatParcelaBaja" style={{ display: 'block', marginBottom: '6px', color: '#666' }}>
              Motivo de la baja
            </label>
            <Select
              inputId="idCatParcelaBaja"
              options={opcionesCatalogo}
              value={
                formData.idCatParcelaBaja
                  ? opcionesCatalogo.find(opt => opt.value === formData.idCatParcelaBaja)
                  : null
              }
              onChange={onChangeSelect}
              placeholder="Selecciona un motivo"
              className="react-select-container"
              classNamePrefix="react-select"
              styles={{
                control: (base, state) => ({
                  ...base,
                  borderColor: errors.idCatParcelaBaja ? '#D9534F' : '#DADADA',
                  borderWidth: '1px',
                  minHeight: '38px',
                  '&:hover': {
                    borderColor: errors.idCatParcelaBaja ? '#D9534F' : '#DADADA',
                  },
                }),
              }}
              isClearable
            />
            {errors.idCatParcelaBaja ? <small style={{ color: '#D9534F' }}>{errors.idCatParcelaBaja}</small> : null}
          </div>
        </div>
      </div>
    </ModalGeneral>
  );
};

export default ModalParcelas;
